<script lang="ts">
  const handleClick = () => {
    window.open('https://calendly.com/infinitrotech/30min', '_blank');
  };
</script>
<div class="flex flex-col items-center justify-center p-6 space-y-8 bg-blue-500 shadow-2xl rounded-3xl w-full max-w-screen-lg mx-auto">
    <div class="text-3xl tracking-tighter text-white">Let's meet and discuss your business needs.</div>
    <button on:click={handleClick} class="px-5 py-2.5 mt-4 text-base font-medium leading-5 text-stone-950 bg-white rounded-full shadow hover:shadow-lg">
      Book a Call
    </button>
</div>